<template>
    <v-app>
        <v-row>
            <v-col>
                <v-row>
                    <v-alert
                    v-model="alert"
                    border="left"
                    close-text="Close Alert"
                    color="success accent-4"
                    dark
                    width="500"
                    dismissible
                    >
                        <v-row class="ma-8" justify="center"><h2>The pdf file has been created</h2></v-row>
                        <v-row class="ma-8" justify="center">Your download should have already started.</v-row> 
                    </v-alert>
                </v-row>
            </v-col>
        </v-row>
    </v-app>
    
</template>

<script>
import axios from "axios";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
export default {
data(){
    return{
        alert:false,
        maildata:"check",
        mailaddress:"check",
        taxrates:"check",
        ns:false,
        l1:'',
        l2:'',
        l3:'',
        l4:'',
        l5:'',
        l6:'',
    }
},
methods:{
    premakepdf(){
        if(this.maildata == "check" || this.mailaddress == "check" || this.taxrates == "check"){ //make sure all the data has returned before printing the pdf
            setTimeout(this.premakepdf, 200);
        }else{
            this.makepdf();
        }
    },
   makepdf(){

        var doc = new jsPDF('p','in',[8.5, 11]);
        //const moneyformatter = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        var imgData = "data:image/jpeg;base64,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";
        doc.addImage(imgData, 'JPEG', .4, .18, .6, .8); //xy of top left corner then the width and height of the picture    
///////////////////add top veriable
 let y=-.2; 


        doc.setFont("times","bold");
        doc.setFontSize(11);
        doc.text(1.2, .30, 'CITY OF BREMERTON');
        doc.text(1.2, .45, 'Tax & License Division');
        doc.setFontSize(8);
        doc.setFont("times","normal");
        doc.text(1.2, .62, '345 Sixth Street, Suite 100');
        doc.text(1.2, .74, 'Bremerton WA 98337-1891');
        doc.text(1.2, .86, 'Phone: (360) 473-5311 Fax (360) 473-5300');
        doc.text(1.2, .98, 'www.bremertonwa.gov email: taxinfo@ci.bremerton.wa.us');
let n=.4; 
let nn=.2;
        doc.setFontSize(11);
        doc.setFont("times","bold");
        doc.text(n,nn+ 1.25, 'BUSINESS TAX RETURN');
        doc.setFontSize(8);
        doc.text(6.9, y+1.5, 'Questions?');
        doc.text(6.82,y+ 1.65, '(360) 473-5311');
/////////////////////////////////////////////////Address 
        doc.setFontSize(8);
        doc.setFont("times","normal");
        doc.text(n,nn+ 1.4, this.l1);
let nnn = nn+1.4;
        if(this.l2 != "null"){nnn=nnn+.15; doc.text(n,nnn, this.l2);}
        if(this.l3 != "null"){nnn=nnn+.15; doc.text(n,nnn, this.l3);}
        if(this.l4 !="null"){nnn=nnn+.15; doc.text(n,nnn, this.l4);}
        if(this.l5 !="null"){nnn=nnn+.15; doc.text(n,nnn, this.l5); }
        if(this.l6 !="null"){nnn=nnn+.15; doc.text(n,nn+  2.15, this.l6);}
        doc.setFontSize(10);
        doc.text(.44,y+ 2.7, 'Be sure name & address are correct.'); 

      

 ////////////////////////////////////////////////account no          
        doc.setFontSize(8);
        doc.setFont("times","normal");
        doc.text(6.72,y+ 1.84, 'Account/License No.');
        doc.setFontSize(11);
        doc.setLineWidth(0.01);
        let accnt=this.maildata.accnt.trim();
        doc.rect(6.44,y+1.72,1.5,.55);
        doc.setFont("times","bold");
        doc.setFontSize(14);
        doc.text(6.95, y+2.07, accnt);  
        
  ////////////////////////////////////////////////Date Due        
        doc.setFont("times","normal");
        doc.setFontSize(8);
        doc.text(6.97, y+2.39, 'Date Due');
        doc.setFontSize(11);
        doc.setLineWidth(0.01);
        let dd=this.maildata.datedue.trim();
        doc.rect(6.44,y+2.27,1.5,.55);
        doc.setFont("times","bold");
        doc.setFontSize(12);
        doc.text(6.59, y+2.62, dd);     
        
//////////////////////////////////////////////////tax period
        doc.setFont("times","normal");
        doc.setFontSize(8);
        doc.text(5.44,y+ 2.39, 'Tax Period');
        doc.setFontSize(11);
        doc.setLineWidth(0.01);
        let tp=this.maildata.taxperiod.trim();
        doc.rect(4.94,y+2.27,1.5,.55);
        doc.setFont("times","bold");
        doc.setFontSize(12);
        doc.text(5.25, y+2.62, tp); 

///////////////////////////////////////////////////Header Box
        doc.setFillColor(230,230,230);
        doc.rect(.4,y+2.82,7.54,.33,'FD');
        doc.setFont("times","normal");
        doc.setFontSize(8);    
        doc.text(.5, y+3, 'Business Classification');
        doc.text(2.52, y+3, 'Gross Amount');
        doc.text(3.6, y+3, 'Deductions');
        doc.text(4.6, y+3, 'Exemption');
        doc.text(5.48, y+3, 'Taxable Amount');
        doc.text(6.51, y+3, 'Rate');
        doc.text(7.35, y+3, 'Tax Due');

////////////////////////////////////////////////classifications
        doc.rect(.4,y+3.15,2,.2);
        doc.text(.5, y+3.28, '01 Retail');
        doc.text(1.8, y+3.28, '(B&O)');

        doc.rect(.4,y+3.35,2,.2);
        doc.text(.5, y+3.48, '02 Wholesale/MFG');
        doc.text(1.8, y+3.48, '(B&O)');

        doc.rect(.4,y+3.55,2,.2);
        doc.text(.5, y+3.68, '03 Service');
        doc.text(1.8, y+3.68, '(B&O)');

        doc.rect(.4,y+3.75,2,.2);
        doc.text(.5, y+3.88, '04 Manufacturing');
        doc.text(1.8, y+3.88, '(B&O)');

        doc.rect(.4,y+3.95,7.54,.33);
        doc.setFont("times","bold");
        doc.setFontSize(10); 
        doc.text(1.8, y+4.15, 'If filing B&O tax you are eligible to take an annual Exemption of up to $');
        doc.text(6.1, y+4.15, this.maildata.exemptionrate);
        doc.setFont("times","normal");
        doc.setFontSize(8); 

        doc.rect(.4,y+4.28,2,.2);
        doc.text(.5, y+4.42, '09 Amusement Device/Games');

        doc.rect(.4,y+4.48,2,.2);
        doc.text(.5, y+4.62, '10 Punchboard/Pulltab (profit)');

        doc.rect(.4,y+4.68,2,.2);
        doc.text(.5, y+4.82, '11 Punchboard/Pulltab (non-profit)');

        doc.rect(.4,y+4.88,2,.2);
        doc.text(.5, y+5.02, '12 Card Rooms (Player Backed)');

        doc.rect(.4,y+5.08,2,.2);
        doc.text(.5, y+5.22, '13 Card Rooms (House Backed)');

        doc.rect(.4,y+5.28,2,.2);
        doc.text(.5, y+5.42, '14 Bingo/Raffles');

        doc.rect(.4,y+5.48,2,.2);
        doc.text(.5, y+5.62, '16 Other Gambling');

        doc.rect(.4,y+5.68,2,.2);
        doc.text(.5, y+5.82, '21 Parking Lot');

        doc.rect(.4,y+5.88,2,.2);
        doc.text(.5, y+6.02, '23 Electric');

        doc.rect(.4,y+6.08,2,.2);
        doc.text(.5, y+6.22, '24 Gas');

        doc.rect(.4,y+6.28,2,.2);
        doc.text(.5, y+6.42, '25 Telephone');

        doc.rect(.4,y+6.68,2,.2);
        doc.text(.5, y+6.62, '26 Garbage Utility');

        doc.rect(.4,y+6.48,2,.2);
        doc.text(.5, y+6.82, '27 Cable Utility');

        

////////////////////////////////////////////////////// Amounts
        let x1=.99;
        let x1b=.8;
        let rg="";
        let rd="";
        if(this.maildata.pay[0].retailg!=""){
            rg=parseFloat(this.maildata.pay[0].retailg);
            rg=rg.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","); //this regular expression removes any decimal point pas two places
            }
        if(this.maildata.pay[0].retaild!=""){
            rd=parseFloat(this.maildata.pay[0].retaild);
            rd=rd.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","); 
            }
//1 retail
        doc.rect(2.4,y+3.15,x1,.2);
        doc.text(2.5+x1b, y+3.28, rg, {align:'right'});
        doc.rect(2.4+x1,y+3.15,x1,.2);
        doc.text(2.5+x1+x1b, y+3.28, rd, {align:'right'});
        doc.rect(2.4+(2*x1),y+3.15,x1,.2);
            if(this.maildata.pay[0].retaile!=""){
                doc.text(2.5+(2*x1)+x1b, y+3.28, parseFloat(this.maildata.pay[0].retaile).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.rect(2.4+(3*x1),y+3.15,x1,.2);
        doc.text(2.5+(3*x1)+x1b, y+3.28, parseFloat(this.maildata.pay[0].retailta).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            doc.rect(2.4+(4*x1),y+3.15,.5,.2)
            //rate=(this.maildata.pay[0].retailtd/this.maildata.pay[0].retailta).toFixed(5).toString();
            //if(rate === "NaN"){rate = "";}
            doc.text(2.85+(4*x1), y+3.28, this.taxrates.Retail_01.toString(), {align:'right'});
        doc.rect(2.4+(4*x1),y+3.15,x1+.59,.2);
        doc.text(3.38+(4*x1)+.5, y+3.28, this.maildata.pay[0].retailtd.replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
//2 wholesale         
        doc.rect(2.4,y+3.35,x1,.2);
            if(this.maildata.pay[1].wholesaleg!=""){
                doc.text(2.5+x1b, y+3.48, parseFloat(this.maildata.pay[1].wholesaleg).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.rect(2.4+x1,y+3.35,x1,.2);
            if(this.maildata.pay[1].wholesaled!=""){
                doc.text(2.5+x1+x1b, y+3.48, parseFloat(this.maildata.pay[1].wholesaled).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.rect(2.4+(2*x1),y+3.35,x1,.2);
            if(this.maildata.pay[1].wholesalee!=""){
                doc.text(2.5+(2*x1)+x1b, y+3.48, parseFloat(this.maildata.pay[1].wholesalee).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.rect(2.4+(3*x1),y+3.35,x1,.2);
        doc.text(2.5+(3*x1)+x1b, y+3.48, parseFloat(this.maildata.pay[1].wholesaleta).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            doc.rect(2.4+(4*x1),y+3.35,.5,.2)
            //rate=(this.maildata.pay[1].wholesaletd/this.maildata.pay[1].wholesaleta).toFixed(4).toString();
            //if(rate === "NaN"){rate = "";}
            doc.text(2.85+(4*x1), y+3.48, this.taxrates.Wholesale_02.toString(), {align:'right'});
        doc.rect(2.4+(4*x1),y+3.35,x1+.59,.2);
        doc.text(3.38+(4*x1)+.5, y+3.48, this.maildata.pay[1].wholesaletd.replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
//3 service     
        doc.rect(2.4,y+3.55,x1,.2);
            if(this.maildata.pay[2].serviceg!=""){
                doc.text(2.5+x1b, y+3.68, parseFloat(this.maildata.pay[2].serviceg).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.rect(2.4+x1,y+3.55,x1,.2);
            if(this.maildata.pay[2].serviced!=""){
                doc.text(2.5+x1+x1b, y+3.68, parseFloat(this.maildata.pay[2].serviced).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.rect(2.4+(2*x1),y+3.55,x1,.2);
            if(this.maildata.pay[2].servicee!=""){
                doc.text(2.5+(2*x1)+x1b, y+3.68, parseFloat(this.maildata.pay[2].servicee).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.rect(2.4+(3*x1),y+3.55,x1,.2);
        doc.text(2.5+(3*x1)+x1b, y+3.68, parseFloat(this.maildata.pay[2].serviceta).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            doc.rect(2.4+(4*x1),y+3.55,.5,.2)
            //rate=(this.maildata.pay[2].servicetd/this.maildata.pay[2].serviceta).toFixed(3).toString();
            //if(rate === "NaN"){rate = "";}
            doc.text(2.85+(4*x1), y+3.68, this.taxrates.Service_03.toString(), {align:'right'});
        doc.rect(2.4+(4*x1),y+3.55,x1+.59,.2);
        doc.text(3.38+(4*x1)+.5, y+3.68, this.maildata.pay[2].servicetd.replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
//4 manufacturing    
        doc.rect(2.4,y+3.75,x1,.2);
            if(this.maildata.pay[3].manufacturingg!=""){
                doc.text(2.5+x1b, y+3.88, parseFloat(this.maildata.pay[3].manufacturingg).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.rect(2.4+x1,y+3.75,x1,.2);
            if(this.maildata.pay[3].manufacturingd!=""){
                doc.text(2.5+x1+x1b, y+3.88, parseFloat(this.maildata.pay[3].manufacturingd).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.rect(2.4+(2*x1),y+3.75,x1,.2);
            if(this.maildata.pay[3].manufacturinge!=""){
                doc.text(2.5+(2*x1)+x1b, y+3.88, parseFloat(this.maildata.pay[3].manufacturinge).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.rect(2.4+(3*x1),y+3.75,x1,.2);
        doc.text(2.5+(3*x1)+x1b, y+3.88, parseFloat(this.maildata.pay[3].manufacturingta).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            doc.rect(2.4+(4*x1),y+3.75,.5,.2)
            //rate=(this.maildata.pay[3].manufacturingtd/this.maildata.pay[3].manufacturingta).toFixed(4).toString();
            //if(rate === "NaN"){rate = "";}
            doc.text(2.85+(4*x1), y+3.88, this.taxrates.manufacturing.toString(), {align:'right'});
        doc.rect(2.4+(4*x1),y+3.75,x1+.59,.2);
        doc.text(3.38+(4*x1)+.5, y+3.88, this.maildata.pay[3].manufacturingtd.replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
//9 amusement
        doc.rect(2.4,y+4.28,x1,.2);
            if(this.maildata.pay[4].amusementg!=""){
                doc.text(2.5+x1b, y+4.42, parseFloat(this.maildata.pay[4].amusementg).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.setFillColor(230,230,230);
        doc.rect(2.4+x1,y+4.28,x1,.2);
            if(this.maildata.pay[4].amusementd!=""){
                doc.text(2.5+x1+x1b, y+4.42, parseFloat(this.maildata.pay[4].amusementd).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.setFillColor(230,230,230);
        doc.rect(2.4+(2*x1),y+4.28,x1,.2,'FD');
        //doc.text(2.5+(2*x1)+x1b, y+4.42, parseFloat(this.maildata.pay[4].amusemente).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
        doc.rect(2.4+(3*x1),y+4.28,x1,.2);
        doc.text(2.5+(3*x1)+x1b, y+4.42, parseFloat(this.maildata.pay[4].amusementta).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
        doc.rect(2.4+(4*x1),y+4.28,.5,.2)
            //rate=(this.maildata.pay[4].amusementtd/this.maildata.pay[4].amusementta).toFixed(2).toString();
            //if(rate === "NaN"){rate = "";}
            doc.text(2.85+(4*x1), y+4.42, this.taxrates.Amusement_09.toString(), {align:'right'});
        doc.rect(2.4+(4*x1),y+4.28,x1+.59,.2);
        doc.text(3.38+(4*x1)+.5, y+4.42, this.maildata.pay[4].amusementtd.replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
//10 punchcard        
        doc.rect(2.4,y+4.48,x1,.2);
        if(this.maildata.pay[5].punchboardg!=""){
                doc.text(2.5+x1b, y+4.62, parseFloat(this.maildata.pay[5].punchboardg).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.setFillColor(230,230,230);
        doc.rect(2.4+x1,y+4.48,x1,.2,'FD');
        //doc.text(2.5+x1+x1b, y+4.62, parseFloat(this.maildata.pay[5].punchboardd).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
        doc.setFillColor(230,230,230);
        doc.rect(2.4+(2*x1),y+4.48,x1,.2,'FD');
        //doc.text(2.5+(2*x1)+x1b, y+4.62, parseFloat(this.maildata.pay[5].punchboarde).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
        doc.rect(2.4+(3*x1),y+4.48,x1,.2);
        doc.text(2.5+(3*x1)+x1b, y+4.62, parseFloat(this.maildata.pay[5].punchboardta).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            doc.rect(2.4+(4*x1),y+4.48,.5,.2)
            //rate=(this.maildata.pay[5].punchboardtd/this.maildata.pay[5].punchboardta).toFixed(2).toString();
            //if(rate === "NaN"){rate = "";}
            doc.text(2.85+(4*x1), y+4.62, this.taxrates.PunchcardProfit_10.toString(), {align:'right'});
        doc.rect(2.4+(4*x1),y+4.48,x1+.59,.2);
        doc.text(3.38+(4*x1)+.5, y+4.62, this.maildata.pay[5].punchboardtd.replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
//11 punch board
        doc.rect(2.4,y+4.68,x1,.2);
        if(this.maildata.pay[6].punchboardnpg!=""){
                doc.text(2.5+x1b, y+4.82, parseFloat(this.maildata.pay[6].punchboardnpg).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.rect(2.4+x1,y+4.68,x1,.2);
        if(this.maildata.pay[6].punchboardnpd!=""){
                doc.text(2.5+x1+x1b, y+4.82, parseFloat(this.maildata.pay[6].punchboardnpd).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.setFillColor(230,230,230);
        doc.rect(2.4+(2*x1),y+4.68,x1,.2,'FD');
        //doc.text(2.5+(2*x1)+x1b, y+4.82, parseFloat(this.maildata.pay[6].punchboardnpe).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
        doc.rect(2.4+(3*x1),y+4.68,x1,.2);
        doc.text(2.5+(3*x1)+x1b, y+4.82, parseFloat(this.maildata.pay[6].punchboardnpta).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            doc.rect(2.4+(4*x1),y+4.68,.5,.2)
            //rate=(this.maildata.pay[6].punchboardnptd/this.maildata.pay[6].punchboardnpta).toFixed(1).toString();
            //if(rate === "NaN"){rate = "";}
            doc.text(2.85+(4*x1), y+4.82, this.taxrates.PunchcardNonprofit_11.toString(), {align:'right'});
        doc.rect(2.4+(4*x1),y+4.68,x1+.59,.2);
        doc.text(3.38+(4*x1)+.5, y+4.82, this.maildata.pay[6].punchboardnptd.replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
//12 cardplayer
        doc.rect(2.4,y+4.88,x1,.2);
            if(this.maildata.pay[7].cardplayerg!=""){
                doc.text(2.5+x1b, y+5.02, parseFloat(this.maildata.pay[7].cardplayerg).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.setFillColor(230,230,230);
        doc.rect(2.4+x1,y+4.88,x1,.2,'FD');
        //doc.text(2.5+x1+x1b, y+5.02, parseFloat(this.maildata.pay[7].cardplayerd).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
        doc.setFillColor(230,230,230);
        doc.rect(2.4+(2*x1),y+4.88,x1,.2,'FD');
        //doc.text(2.5+(2*x1)+x1b, y+5.02, parseFloat(this.maildata.pay[7].cardplayere).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
        doc.rect(2.4+(3*x1),y+4.88,x1,.2);
        doc.text(2.5+(3*x1)+x1b, y+5.02, parseFloat(this.maildata.pay[7].cardplayerta).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            doc.rect(2.4+(4*x1),y+4.88,.5,.2)
            //rate=(this.maildata.pay[7].cardplayertd/this.maildata.pay[7].cardplayerta).toFixed(1).toString();
            //if(rate === "NaN"){rate = "";}
            doc.text(2.85+(4*x1), y+5.02, this.taxrates.CardroomsPlayer_12.toString(), {align:'right'});
        doc.rect(2.4+(4*x1),y+4.88,x1+.59,.2);
        doc.text(3.38+(4*x1)+.5, y+5.02, this.maildata.pay[7].cardplayertd.replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
//13 cardhouse
        doc.rect(2.4,y+5.08,x1,.2);
        if(this.maildata.pay[8].cardhouseg!=""){
                doc.text(2.5+x1b, y+5.22, parseFloat(this.maildata.pay[8].cardhouseg).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.rect(2.4+x1,y+5.08,x1,.2);
        if(this.maildata.pay[8].cardhoused!=""){
            doc.text(2.5+x1+x1b, y+5.22, parseFloat(this.maildata.pay[8].cardhoused).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.setFillColor(230,230,230);
        doc.rect(2.4+(2*x1),y+5.08,x1,.2,'FD');
        //doc.text(2.5+(2*x1)+x1b, y+5.22, parseFloat(this.maildata.pay[8].cardhousee).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
        doc.rect(2.4+(3*x1),y+5.08,x1,.2);
        doc.text(2.5+(3*x1)+x1b, y+5.22, parseFloat(this.maildata.pay[8].cardhouseta).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            doc.rect(2.4+(4*x1),y+5.08,.5,.2)
            //rate=(this.maildata.pay[8].cardhousetd/this.maildata.pay[8].cardhouseta).toFixed(2).toString();
            //if(rate === "NaN"){rate = "";}
            doc.text(2.85+(4*x1), y+5.22, this.taxrates.CardroomsHouse_13.toString(), {align:'right'});
        doc.rect(2.4+(4*x1),y+5.08,x1+.59,.2);
        doc.text(3.38+(4*x1)+.5, y+5.22, this.maildata.pay[8].cardhousetd.replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
//14 bingo
        doc.rect(2.4,y+5.28,x1,.2);
        if(this.maildata.pay[9].bingog!=""){
            doc.text(2.5+x1b, y+5.42, parseFloat(this.maildata.pay[9].bingog).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.rect(2.4+x1,y+5.28,x1,.2);
        if(this.maildata.pay[9].bingod!=""){
            doc.text(2.5+x1+x1b, y+5.42, parseFloat(this.maildata.pay[9].bingod).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.setFillColor(230,230,230);
        doc.rect(2.4+(2*x1),y+5.28,x1,.2,'FD');
        //doc.text(2.5+(2*x1)+x1b, y+5.42, parseFloat(this.maildata.pay[9].bingoe).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
        doc.rect(2.4+(3*x1),y+5.28,x1,.2);
        doc.text(2.5+(3*x1)+x1b, y+5.42, parseFloat(this.maildata.pay[9].bingota).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            doc.rect(2.4+(4*x1),y+5.28,.5,.2)
            //rate=(this.maildata.pay[9].bingotd/this.maildata.pay[9].bingota).toFixed(2).toString();
            //if(rate === "NaN"){rate = "";}
            doc.text(2.85+(4*x1), y+5.42, this.taxrates.BingoRaffle_14.toString(), {align:'right'});
        doc.rect(2.4+(4*x1),y+5.28,x1+.59,.2);
        doc.text(3.38+(4*x1)+.5, y+5.42, this.maildata.pay[9].bingotd.replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
//16 gambleing
        doc.rect(2.4,y+5.48,x1,.2);
        if(this.maildata.pay[10].gambleg!=""){
            doc.text(2.5+x1b, y+5.62,parseFloat(this.maildata.pay[10].gambleg).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.rect(2.4+x1,y+5.48,x1,.2);
        if(this.maildata.pay[10].gambled!=""){
            doc.text(2.5+x1+x1b, y+5.62, parseFloat(this.maildata.pay[10].gambled).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.setFillColor(230,230,230);
        doc.rect(2.4+(2*x1),y+5.48,x1,.2,'FD');
        //doc.text(2.5+(2*x1)+x1b, y+5.62, parseFloat(this.maildata.pay[10].gamblee).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
        doc.rect(2.4+(3*x1),y+5.48,x1,.2);
        doc.text(2.5+(3*x1)+x1b, y+5.62, parseFloat(this.maildata.pay[10].gambleta).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            doc.rect(2.4+(4*x1),y+5.48,.5,.2)
            //rate=(this.maildata.pay[10].gambletd/this.maildata.pay[10].gambleta).toFixed(1).toString();
            //if(rate === "NaN"){rate = "";}
            doc.text(2.85+(4*x1), y+5.62, this.taxrates.OtherGambling_16.toString(), {align:'right'});
        doc.rect(2.4+(4*x1),y+5.48,x1+.59,.2);
        doc.text(3.38+(4*x1)+.5, y+5.62, this.maildata.pay[10].gambletd.replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
//21 park
        doc.rect(2.4,y+5.68,x1,.2);
        if(this.maildata.pay[11].parkg!=""){
            doc.text(2.5+x1b, y+5.82,parseFloat(this.maildata.pay[11].parkg).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.setFillColor(230,230,230);
        doc.rect(2.4+x1,y+5.68,x1,.2,'FD');
        //doc.text(2.5+x1+x1b, y+5.82, parseFloat(this.maildata.pay[11].parkd).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
        doc.setFillColor(230,230,230);
        doc.rect(2.4+(2*x1),y+5.68,x1,.2,'FD');
       // doc.text(2.5+(2*x1)+x1b, y+5.82, parseFloat(this.maildata.pay[11].parke).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
        doc.rect(2.4+(3*x1),y+5.68,x1,.2);
        doc.text(2.5+(3*x1)+x1b, y+5.82, parseFloat(this.maildata.pay[11].parkta).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            doc.rect(2.4+(4*x1),y+5.68,.5,.2)
            //rate=(this.maildata.pay[11].parktd/this.maildata.pay[11].parkta).toFixed(2).toString();
            //if(rate === "NaN"){rate = "";}
            doc.text(2.85+(4*x1), y+5.82, this.taxrates.Parkinglot_21.toString(), {align:'right'});
        doc.rect(2.4+(4*x1),y+5.68,x1+.59,.2);
        doc.text(3.38+(4*x1)+.5, y+5.82, this.maildata.pay[11].parktd.replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
//23 electric
        doc.rect(2.4,y+5.88,x1,.2);
        if(this.maildata.pay[16].electricg!=""){
            doc.text(2.5+x1b, y+6.02, parseFloat(this.maildata.pay[16].electricg).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            } 
        doc.rect(2.4+x1,y+5.88,x1,.2);
        if(this.maildata.pay[16].electricd!=""){
            doc.text(2.5+x1+x1b, y+6.02, parseFloat(this.maildata.pay[16].electricd).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.setFillColor(230,230,230);
        doc.rect(2.4+(2*x1),y+5.88,x1,.2,'FD');
        //doc.text(2.5+(2*x1)+x1b, y+6.02, parseFloat(this.maildata.pay[16].electrice).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
        doc.rect(2.4+(3*x1),y+5.88,x1,.2);
        doc.text(2.5+(3*x1)+x1b, y+6.02, parseFloat(this.maildata.pay[16].electricta).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            doc.rect(2.4+(4*x1),y+5.88,.5,.2)
            //rate=(this.maildata.pay[16].electrictd/this.maildata.pay[16].electricta).toFixed(2).toString();
            //if(rate === "NaN"){rate = "";}
            doc.text(2.85+(4*x1), y+6.02, this.taxrates.Electric_23.toString(), {align:'right'});
        doc.rect(2.4+(4*x1),y+5.88,x1+.59,.2);
        doc.text(3.38+(4*x1)+.5, y+6.02, this.maildata.pay[16].electrictd.replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
//24 gas
        doc.rect(2.4,y+6.08,x1,.2);
        if(this.maildata.pay[15].gasg!=""){
            doc.text(2.5+x1b, y+6.22, parseFloat(this.maildata.pay[15].gasg).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.rect(2.4+x1,y+6.08,x1,.2);
        if(this.maildata.pay[15].gasd!=""){
            doc.text(2.5+x1+x1b, y+6.22, parseFloat(this.maildata.pay[15].gasd).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.setFillColor(230,230,230);
        doc.rect(2.4+(2*x1),y+6.08,x1,.2,'FD');
        //doc.text(2.5+(2*x1)+x1b, y+6.22, parseFloat(this.maildata.pay[15].gase).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
        doc.rect(2.4+(3*x1),y+6.08,x1,.2);
        doc.text(2.5+(3*x1)+x1b, y+6.22, parseFloat(this.maildata.pay[15].gasta).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            doc.rect(2.4+(4*x1),y+6.08,.5,.2)
            //rate=(this.maildata.pay[15].gastd/this.maildata.pay[15].gasta).toFixed(2).toString();
            //if(rate === "NaN"){rate = "";}
            doc.text(2.85+(4*x1), y+6.22, this.taxrates.Gas_24.toString(), {align:'right'});
        doc.rect(2.4+(4*x1),y+6.08,x1+.59,.2);
        doc.text(3.38+(4*x1)+.5, y+6.22, this.maildata.pay[15].gastd.replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
//25 telephone
        doc.rect(2.4,y+6.28,x1,.2);
        if(this.maildata.pay[14].telephoneg!=""){
            doc.text(2.5+x1b, y+6.42, parseFloat(this.maildata.pay[14].telephoneg).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.rect(2.4+x1,y+6.28,x1,.2);
        if(this.maildata.pay[14].telephoned!=""){
            doc.text(2.5+x1+x1b, y+6.42, parseFloat(this.maildata.pay[14].telephoned).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.setFillColor(230,230,230);
        doc.rect(2.4+(2*x1),y+6.28,x1,.2,'FD');
        //doc.text(2.5+(2*x1)+x1b, y+6.42, parseFloat(this.maildata.pay[14].telephonee).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
        doc.rect(2.4+(3*x1),y+6.28,x1,.2);
        doc.text(2.5+(3*x1)+x1b, y+6.42, parseFloat(this.maildata.pay[14].telephoneta).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            doc.rect(2.4+(4*x1),y+6.28,.5,.2)
            //rate=(this.maildata.pay[14].telephonetd/this.maildata.pay[14].telephoneta).toFixed(2).toString();
            //if(rate === "NaN"){rate = "";}
            doc.text(2.85+(4*x1), y+6.42, this.taxrates.Telephone_25.toString(), {align:'right'});
        doc.rect(2.4+(4*x1),y+6.28,x1+.59,.2);
        doc.text(3.38+(4*x1)+.5, y+6.42, this.maildata.pay[14].telephonetd.replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
//26 garbage
        doc.rect(2.4,y+6.48,x1,.2);
        if(this.maildata.pay[12].garbageg!=""){
            doc.text(2.5+x1b, y+6.62, parseFloat(this.maildata.pay[12].garbageg).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.rect(2.4+x1,y+6.48,x1,.2);
        if(this.maildata.pay[12].garbaged!=""){
            doc.text(2.5+x1+x1b, y+6.62, parseFloat(this.maildata.pay[12].garbaged).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.setFillColor(230,230,230);
        doc.rect(2.4+(2*x1),y+6.48,x1,.2,'FD');
        //doc.text(2.5+(2*x1)+x1b, y+6.62, parseFloat(this.maildata.pay[12].garbagee).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
        doc.rect(2.4+(3*x1),y+6.48,x1,.2);
        doc.text(2.5+(3*x1)+x1b, y+6.62, parseFloat(this.maildata.pay[12].garbageta).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            doc.rect(2.4+(4*x1),y+6.48,.5,.2)
            //rate=(this.maildata.pay[12].garbagetd/this.maildata.pay[12].garbageta).toFixed(3).toString();
            //if(rate === "NaN"){rate = "";}
            doc.text(2.85+(4*x1), y+6.62, this.taxrates.GarbageUtility_26.toString(), {align:'right'});
        doc.rect(2.4+(4*x1),y+6.48,x1+.59,.2);
        doc.text(3.38+(4*x1)+.5, y+6.62, this.maildata.pay[12].garbagetd.replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});

//29 cable
        doc.rect(2.4,y+6.68,x1,.2);
        if(this.maildata.pay[13].cableg!=""){
            doc.text(2.5+x1b, y+6.82, parseFloat(this.maildata.pay[13].cableg).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.rect(2.4+x1,y+6.68,x1,.2);
        if(this.maildata.pay[13].cabled!=""){
            doc.text(2.5+x1+x1b, y+6.82, parseFloat(this.maildata.pay[13].cabled).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            }
        doc.setFillColor(230,230,230);
        doc.rect(2.4+(2*x1),y+6.68,x1,.2,'FD');
        //doc.text(2.5+(2*x1)+x1b, y+6.82, parseFloat(this.maildata.pay[13].cablee).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
        doc.rect(2.4+(3*x1),y+6.68,x1,.2);
        doc.text(2.5+(3*x1)+x1b, y+6.82, parseFloat(this.maildata.pay[13].cableta).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
            doc.rect(2.4+(4*x1),y+6.68,.5,.2)
            //rate=(this.maildata.pay[13].cabletd/this.maildata.pay[13].cableta).toFixed(2).toString();
            //if(rate === "NaN"){rate = "";}
            doc.text(2.85+(4*x1), y+6.82, this.taxrates.CableUtility_29.toString(), {align:'right'});
        doc.rect(2.4+(4*x1),y+6.68,x1+.59,.2);
        doc.text(3.38+(4*x1)+.5, y+6.82, this.maildata.pay[13].cabletd.replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
///////////////////////////////////////////////////////////////////////deduction explanations
    y=.4;
        doc.setFillColor(230,230,230);
        doc.rect(.4,y+6.28,5.33,.2);
        doc.setFont("times","bold");
        doc.setFontSize(10); 
        let ex="";
        //let na="";
        //let am="";
        doc.text(1.54, y+6.42, "***Unexplained deductions will not be allowed.***");

        doc.setFont("times","normal");
        doc.setFontSize(8);
        for(let i=0;i<this.maildata.explanations.length;i++){
            ex=this.maildata.explanations[i].name + ": " + this.maildata.explanations[i].explanation;
            let exl=118
            if(ex.length>exl){
                ex=ex.substring(0,exl)+"...";
            }
            //na=this.maildata.explanations[i].name;
            //am=this.maildata.exemptions[i];

            ////////////////////////////////////////////////////draw box
            doc.rect(.4,y+6.28+(i*.2)+.2,5.33,.2);
            ////////////////////////////////////////////////////add text
            doc.text(.5, y+6.42+(i*.2)+.2,ex);

        }
          
////////////////////////////////////////////////////////////////////////// show totals
x1=x1+.12;
        
        doc.setFont("times","bold");
        doc.setFontSize(8);
        doc.setFillColor(255,252,192);
        doc.rect(2.4+(3*x1),y+6.28,x1+.025,.2,'FD');
        doc.text(2.44+(3*x1),y+6.43,'Total Tax');
        doc.setFillColor(255,252,192);
        doc.rect(2.4+(3*x1),y+6.48,x1+.025,.2,'FD');
        doc.text(2.44+(3*x1),y+6.63,'Penalties');
        doc.setFillColor(255,252,192);
        doc.rect(2.4+(3*x1),y+6.68,x1+.025,.2,'FD');
        doc.text(2.44+(3*x1),y+6.83,'Total Tax and Penalty');
        doc.setFillColor(255,252,192);
        doc.rect(2.4+(3*x1),y+6.88,x1+.025,.2,'FD');
        doc.text(2.44+(3*x1),y+7.03,'Balance Forward');
        doc.setFillColor(255,252,122);
        doc.rect(2.4+(3*x1),y+7.08,x1+.025,.2,'FD');
        doc.text(2.44+(3*x1),y+7.23,'Amount Paid');

let t=parseFloat(this.maildata.totaltax.substring(1));
let p=parseFloat(this.maildata.penalty.substring(1));
let tap=(t+p).toFixed(2);

        doc.setFillColor(255,252,192);
        doc.rect(2.4+(4*x1)+.025,y+6.28,x1-.025,.2,'FD');
        doc.text(3.4+(4*x1),y+6.43,this.maildata.totaltax.replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
        doc.setFillColor(255,252,192);
        doc.rect(2.4+(4*x1)+.025,y+6.48,x1-.025,.2,'FD');
        doc.text(3.4+(4*x1),y+6.63,this.maildata.penalty.replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
        doc.setFillColor(255,252,192);
        doc.rect(2.4+(4*x1)+.025,y+6.68,x1-.025,.2,'FD');
        doc.text(3.4+(4*x1),y+6.83,"$"+tap.replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
        doc.setFillColor(255,252,192);
        doc.rect(2.4+(4*x1)+.025,y+6.88,x1-.025,.2,'FD');
        doc.text(3.4+(4*x1),y+7.03,this.maildata.balanceforward.replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});
        doc.setFillColor(255,252,122);
        doc.rect(2.4+(4*x1)+.025,y+7.08,x1-.025,.2,'FD');
        doc.text(3.4+(4*x1),y+7.23,this.maildata.grandtotal.replace(/\B(?=(\d{3})+(?!\d))/g, ","), {align:'right'});

/////////////////////////////////////////////////////////////////////////footer
        doc.text(1.9,8.4,"**Service Income Appointment Worksheet is available on our website under Forms/Business/Finance");
let yy=.08
        doc.rect(.4,8.5,3.4,2);
        doc.setFont("times","bold");
        doc.setFontSize(9);
        doc.text(.5,8.7,"If you would like to close your account please complete:" );
        doc.setFont("times","normal");
        doc.setFontSize(8);
        doc.text(.5,8.9+yy,"I discontinued doing business in Bremerton on (date) ______________" );
        doc.text(.5,9.1+(2*yy),"I closed my business on (date) ________________________________" );
        doc.text(.5,9.3+(3*yy),"I sold my business on (date) __________________________________" );
        doc.text(.5,9.5+(4*yy),"New owners name address and phone __________________________" );
        doc.text(.5,9.7+(5*yy),"_________________________________________________________" );
        doc.text(.5,9.9+(6*yy),"_________________________________________________________" );

        doc.rect(3.8,8.5,4.14,2);
        doc.setFont("times","bold");
        doc.setFontSize(10);
        doc.text(5.27,8.7,"Signature Required" );
        doc.setFont("times","normal");
        doc.setFontSize(8);
        doc.text(3.9,8.9,"The taxpayer hereby declares that he/she has read this tax return and certifies it" );
        doc.text(3.9,9,"to be correct:" );
        doc.text(3.9,9.1+(2*yy),"Print Name:        _________________________________________________________" );
        doc.text(3.9,9.3+(3*yy),"Signed:               _________________________________________________________" );
        doc.text(3.9,9.5+(4*yy),"Title:                   _________________________________________________________" );
        doc.text(3.9,9.7+(5*yy),"Phone:                 _________________________________________________________" );

        ////////////////////////////////////autofill signature lines for pay online and zero tax, but not for mail in returns
        if(this.ns != true){
            doc.setFontSize(12);
            doc.text(4.7,9.1+(2*yy),this.maildata.firstname.trim() + " " + this.maildata.lastname);
            doc.text(4.7,9.3+(3*yy),"Electronically Signed");
            if(this.maildata.positn.trim() != "null"){doc.text(4.7,9.5+(4*yy),this.maildata.positn.trim() );}
            if(this.maildata.phone.trim() != "null"){doc.text(4.7,9.7+(5*yy),this.maildata.phone.trim() );}
            doc.setFontSize(8);
        }
        doc.setFont("times","bold");
        doc.text(4.74,9.8+(6*yy),"Unsigned forms will be returned for signature" );
        doc.setFontSize(7);
        doc.setFont("times","normal");
        let d=new Date;
        let printedon=d.getMonth()+"/"+d.getDate()+"/"+d.getFullYear();
        let stamp="This document was printed from https://taxandlicense.bremertonwa.gov/ on "+printedon+".  Document no. "+ this.maildata.prikey;
    
        doc.text(.4,10.15+(6*yy),stamp);
        //doc.save('taxes.pdf');
        doc.save('taxes.pdf', {returnPromise:true}).then(this.donemessage());
    }, 
    //doc.setLineWidth(0.01);
    //doc.line(.35, .5, 7.9, .5); //lines are x,y to x,y
    donemessage(){
        this.alert=true;
    },
    getdata(){
        this.ns=false;
        let thisvue = this;
        let url = this.$store.state.url;
        let submitdate=this.$store.state.paytime;
        
        const params = new URLSearchParams();
        params.append('ty', 'getmail');
        params.append('submitdate' , submitdate);
        
        axios({
            method:"post",
            url:url,
            data:params
        })
        .then(function(response){
            thisvue.maildata=response.data;
        })
        .then(function(){
            thisvue.maildata.pay=JSON.parse(thisvue.maildata.pay);
            thisvue.maildata.deductions=JSON.parse(thisvue.maildata.deductions);
            thisvue.maildata.exemptions=JSON.parse(thisvue.maildata.exemptions);
            thisvue.maildata.explanations=JSON.parse(thisvue.maildata.explanations);
            //thisvue.getaddress();
        }).then(function(){
            thisvue.gettaxrates();
        }).then(function(){
            thisvue.getaddress();
        });
    },
    getdatans(){////get data with no electronic signature ns
   
        this.ns=true;
        let thisvue = this;
        let url = this.$store.state.url;
        let submitdate=this.$store.state.paytime;
        
        const params = new URLSearchParams();
        params.append('ty', 'getmail');
        params.append('submitdate' , submitdate);
        
        axios({
            method:"post",
            url:url,
            data:params
        })
        .then(function(response){
            thisvue.maildata=response.data;
        })
        .then(function(){
            thisvue.maildata.pay=JSON.parse(thisvue.maildata.pay);
            thisvue.maildata.deductions=JSON.parse(thisvue.maildata.deductions);
            thisvue.maildata.exemptions=JSON.parse(thisvue.maildata.exemptions);
            thisvue.maildata.explanations=JSON.parse(thisvue.maildata.explanations);
        }).then(function(){
            thisvue.gettaxrates();
        }).then(function(){
            thisvue.getaddress();
        });
    },
    getaddress(){
        let thisvue = this;
        let url = this.$store.state.url;
        let prikey=this.maildata.companyprikey;
        
        const params = new URLSearchParams();
        params.append('ty', 'acntAddress');
        params.append('prikey' , prikey);
        
        axios({
            method:"post",
            url:url,
            data:params
        })
        .then(function(response){
            thisvue.mailaddress=response.data;
        })
        .then(function(){
            thisvue.formataddress();
        })
        .then(function(){
            thisvue.premakepdf();
        });
    },
    formataddress(){
        let l1="";
        let l2="";
        let l3="";
        let l4="";
        let l5="";
        if(this.mailaddress.BusName){l1=this.mailaddress.BusName;}
        if(this.mailaddress.LocAdr1){l2=this.mailaddress.LocAdr1;}
        if(this.mailaddress.LocAdr2){l3=this.mailaddress.LocAdr2;}
        if(this.mailaddress.LocAdr3){l4=this.mailaddress.LocAdr3;}
        
        l5=this.mailaddress.LocCity+" "+this.mailaddress.LocState+", "+this.mailaddress.LocZip;
        
        if(l4==""){l4=l5;l5=" ";}
        if(l3==""){l3=l4;l4=" ";}

        this.l1=l1;
        this.l2=l2;
        this.l3=l3;
        this.l4=l4;
        this.l5=l5;
    },
    gettaxrates(){
       
        let thisvue = this;
        let url = this.$store.state.url;
        let submitdate=this.maildata.submitdate.date;
 
      
        const params = new URLSearchParams();
        params.append('ty', 'gettaxrates');
        params.append('submitdate' , submitdate);
        
            axios({
                method:"post",
                url:url,
                data:params
            })
            .then(function(response){
                thisvue.taxrates=response.data;
            });
        }
    },
}
</script>

<style>

</style>